'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenReaderItemInfo = function ScreenReaderItemInfo(_ref) {
  var format = _ref.format,
      title = _ref.title,
      authors = _ref.authors;

  var hasAuthors = authors && (authors.size || authors.length);
  var firstAuthor = void 0;
  if (hasAuthors) {
    firstAuthor = Array.isArray(authors) ? authors[0] : authors.first();
  }

  return _react2.default.createElement(
    _baseScreenReaderMessage2.default,
    { className: 'cp-screen-reader-item-info' },
    '\u2014 ',
    title,
    ',\xA0',
    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FORMAT.' + (format && format.toLowerCase()) }),
    '\xA0',
    hasAuthors ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'by_authors', values: { authorLinks: firstAuthor } }) : null
  );
};

ScreenReaderItemInfo.propTypes = {
  format: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired,
  authors: _react.PropTypes.oneOfType([_reactImmutableProptypes2.default.listOf(_react2.default.PropTypes.string), _react.PropTypes.arrayOf(_react.PropTypes.string)])
};

exports.default = ScreenReaderItemInfo;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-screen-reader-item-info/lib/components/ScreenReaderItemInfo.component.js
// module id = 1506
// module chunks = 1